module.exports = __webpack_public_path__ + "static/media/tutorial-influence.da2d9ef1.gif";